export interface OfferContainerProps {
    loanNumber: string;
    updateLoanType: (content: string) => void;
    offerDetails?: Offer;
    flags?: Record<string, boolean>;
}
export interface Offer {
    AVMConfidenceScore: number;
    DNISNo: string;
    DOB: string;
    UPB: number;
    activeoffer: string;
    annualSaving: number;
    appraisedValue: number;
    borrowerFirstName: string;
    borrowerFlag: string;
    borrowerLastName: string;
    cmpgnTrkDiffrnciatr: string;
    copy: string;
    doc: string;
    emailAddress: string;
    estCo: number;
    estimatedHomeValue: number;
    header: string;
    lastUpdtDate: string;
    leadRefSrc: string;
    loanNumber: string;
    loanType: string;
    loanTypeCampaign: string;
    loanTypePurchaseOffer: string;
    loan_Type: string;
    lolSaving: number;
    mktCampaignDesc: string;
    monthVsAnnual: string;
    monthlySaving: number;
    offerExpirationDate: string;
    offerTemplate: string;
    ofrApr: number;
    offerGUID: string;
    ofrInterestRate: number;
    ofrTerm: number;
    originalLoanAmount: number;
    priorityNo: number;
    productCampaign: string;
    productPurchaseOffer: string;
    product_Campaign: string;
    product_co: string;
    product_po: string;
    product_refi: string;
    pushNotif: string;
    pushNotifDate: string;
    ssn: string;
    teaserOffer: string;
    teaserOfferFlg: string;
    teaserTemplate: string;
    tollFreeNo: string;
    ACPtollFreeNo: string;
    trancheAssign: string;
    updatedT: string;
}
export enum ToastType {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS'
}
